import { render, staticRenderFns } from "./WorkflowSearchTermsExtraction.vue?vue&type=template&id=1fef2503"
import script from "./WorkflowSearchTermsExtraction.vue?vue&type=script&lang=js"
export * from "./WorkflowSearchTermsExtraction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fef2503')) {
      api.createRecord('1fef2503', component.options)
    } else {
      api.reload('1fef2503', component.options)
    }
    module.hot.accept("./WorkflowSearchTermsExtraction.vue?vue&type=template&id=1fef2503", function () {
      api.rerender('1fef2503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowSearchTermsExtraction.vue"
export default component.exports